// Auto-generated lightweight class for AttachedRecord
// DO NOT EDIT - Changes will be overwritten

import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { AttachedRecordReadAPI, AttachedRecordWriteAPI, AttachedRecordReadAPISchema, AttachedRecordWriteAPISchema } from '../types/attachedrecord';
import { ModelRegistry } from '../../registries/model-registry';
import { AtScope } from '../../relationships/relationship';

import { SecurityScope } from './securityscope';



export interface AttachedRecord extends Partial<AttachedRecordReadAPI> {}
export class AttachedRecord extends NeoNodeBase<AttachedRecordReadAPI, AttachedRecordWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "AttachedRecord";
  static readonly readSchema = AttachedRecordReadAPISchema;
  static readonly writeSchema = AttachedRecordWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
  };

  protected get modelName(): string {
    return 'AttachedRecord';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return AttachedRecord.label;
  }


  constructor(data: Partial<AttachedRecordWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: AttachedRecordReadAPI, loadContext?: Record<string, any>): AttachedRecord {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { security_scope, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = AttachedRecordReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, security_scope: security_scope };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return AttachedRecord.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadOneRelationship(processed, 'security_scope', 'SecurityScope', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new AttachedRecord(processed as any);

    return instance;
  }


  // Relationship manager for 'security_scope' - Python ORM style (cached)
  get security_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('security_scope', () => {
      return new RelationshipManager(this, 'security_scope', 'one', AtScope as typeof Relationship);
    });
  }

}
